import { ButtonGroup } from "../../components/buttons/ButtonGroup";
import {
  PageContainer,
  PageContentContainer,
} from "../../components/PageContainer";
import { InfoText } from "../../components/texts/InfoText";

export const PatientAppNotInstalled = () => {
  const openWebsite = () => {
    window.open("https://www.physiofit.app/patienten", "_blank");
  };

  return (
    <PageContainer>
      <PageContentContainer>
        <InfoText
          headline="Physiofit Heimübungs-App nicht installiert"
          text={[
            "Die Physiofit Heimübungs-App wurde auf deinem Gerät nicht gefunden.",
            "Bitte kontaktiere deine Therapeut:in oder deine Praxis, um die App einzurichten und deinen persönlichen Heimübungsplan zu erhalten.",
          ]}
        />
        <ButtonGroup
          mainButton={{
            text: "Weitere Informationen",
            onClick: openWebsite,
          }}
        />
      </PageContentContainer>
    </PageContainer>
  );
};
